// Copy this into a new component: src/common/Logo.jsx

import React from "react";

export const LogoImg = ({ className = "h-10 w-10" }) => (
  <img 
    src="/logo.png"   // public folder se auto serve hota hai
    alt="GI9 Logo"
    className={className}
  />
);

export const LogoG9 = ({ className = "h-10 w-10" }) => (
  <svg 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    {/* The G/9 Shape */}
    <path 
      d="M50 20 C30 20 15 35 15 55 C15 75 30 90 50 90 H75 V60 H50 C40 60 35 65 35 55 C35 45 40 40 50 40 C60 40 65 45 65 55 V65 H85 V55 C85 30 70 20 50 20 Z" 
      fill="url(#goldGradient)" 
    />
    {/* The "Notification/Bindu" Dot - Represents Digital/Online */}
    <circle cx="75" cy="30" r="8" fill="#EA580C" />
    
    <defs>
      <linearGradient id="goldGradient" x1="15" y1="20" x2="85" y2="90" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FACC15" />
        <stop offset="1" stopColor="#CA8A04" />
      </linearGradient>
    </defs>
  </svg>
);

export const LogoNamaste = ({ className = "h-10 w-10" }) => (
  <svg 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    {/* Envelope Base */}
    <path d="M10 35 L50 65 L90 35 V80 C90 85 85 90 80 90 H20 C15 90 10 85 10 80 V35 Z" fill="#FFF7ED" stroke="#F97316" strokeWidth="4"/>
    
    {/* Namaste Flap (The Fold) */}
    <path d="M10 35 C10 35 30 65 50 65 C70 65 90 35 90 35" stroke="#F97316" strokeWidth="4" strokeLinecap="round" fill="none"/>
    
    {/* The '9' as a seal/sticker */}
    <circle cx="50" cy="55" r="12" fill="#FACC15" />
    <path d="M47 58 L50 51 C52 51 53 53 53 55 C53 57 52 58 50 58 C48 58 47 57 47 55 L47 60" stroke="#B45309" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export const LogoRangoli = ({ className = "h-10 w-10" }) => (
  <svg 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={className}
  >
    {/* Petals */}
    <path d="M50 10 C60 30 70 30 90 50 C70 70 60 70 50 90 C40 70 30 70 10 50 C30 30 40 30 50 10 Z" fill="#FACC15" opacity="0.8"/>
    <path d="M50 10 V90" stroke="#EA580C" strokeWidth="2"/>
    <path d="M10 50 H90" stroke="#EA580C" strokeWidth="2"/>
    
    {/* Center Core */}
    <rect x="35" y="35" width="30" height="30" rx="8" fill="#EA580C" transform="rotate(45 50 50)"/>
    <text x="50" y="56" fontSize="18" fontWeight="bold" fill="white" textAnchor="middle" fontFamily="sans-serif">9</text>
  </svg>
);